import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

/**
 * The prototype's `.ftable` cells (the findings register, the verdict at
 * each snapshot): a paper-100 head, hairline rows, a warm hover. A body
 * row carries `className="group"` so its cells pick up the hover and the
 * last row drops its rule.
 */
export function Th({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <th
      scope="col"
      className={cn(
        'border-b border-ink-100 bg-paper-100 px-3 py-2.5 text-left text-meta font-medium text-ink-500',
        className,
      )}
    >
      {children}
    </th>
  );
}

export function Td({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <td
      className={cn(
        'border-b border-ink-100 px-3 py-2.5 align-middle group-last:border-b-0 group-hover:bg-paper-50',
        className,
      )}
    >
      {children}
    </td>
  );
}
